<template>
  <div class="hero-wrapper">
    <div class="container d-flex flex-grow-1" id="home">
      <div class="row header-hero my-auto">
        <div class="col-lg-7 col-md-8">
          <div class="header-msg">
            HIGH SPEED
            <br />
            <span class="rotating-word">
              <transition name="word-fade" mode="out-in">
                <span :key="currentWord">{{ currentWord }}</span>
              </transition>
            </span>
            <br />INTERNET
          </div>
          <p class="sub mt-3">
            Fast and reliable internet wherever you are. Fiber where
            available, wireless where it's not — so no area gets left behind.
          </p>
          <div class="hero-buttons mt-4">
            <a v-scroll-to="'#plans'" href="#plans" class="btn btn-secondary main-button btn-lg">
              View Plans <i class="fas fa-angle-double-right"></i>
            </a>
            <a v-scroll-to="'#contact'" href="#contact" class="btn second-button main-button btn-lg ms-3">
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="hero-ribbon">
      <div class="container relative">
        <div class="row align-items-center ribbon-cta">
          <div class="col-lg-8 col-md-7 col-12 text-md-start text-center">
            <h4>
              Get Trident Fiber
              <b>for just <small>&#8369;</small>999 / mo</b>
            </h4>
          </div>
          <div class="col-lg-4 col-md-5 col-12 text-md-end text-center mt-md-0 mt-2">
            <a v-scroll-to="'#contact'" href="#contact" class="btn btn-secondary second-button btn-lg ribbon-btn">
              Check coverage in your area
            </a>
          </div>
        </div>
        <div class="row text-center stats-row justify-content-center">
          <div class="col-md-4 col-4 stat-item">
            <div class="stat-number">15+</div>
            <div class="stat-label">Relay Stations</div>
          </div>
          <div class="col-md-4 col-4 stat-item">
            <div class="stat-number">99.9%</div>
            <div class="stat-label">Uptime</div>
          </div>
          <div class="col-md-4 col-4 stat-item">
            <div class="stat-number">24/7</div>
            <div class="stat-label">Support</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeroHeader",
  data() {
    return {
      words: ["FIBER", "WIRELESS"],
      wordIndex: 0
    };
  },
  computed: {
    currentWord() {
      return this.words[this.wordIndex];
    }
  },
  mounted() {
    this.interval = setInterval(() => {
      this.wordIndex = (this.wordIndex + 1) % this.words.length;
      this.$store.commit('setHeroWord', this.words[this.wordIndex].toLowerCase());
    }, 3000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
};
</script>

<style lang="scss" scoped>
.hero-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 140px);
}

.hero-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.ribbon-cta {
  margin-bottom: 16px;
}

.ribbon-btn {
  white-space: nowrap;
}

.stats-row {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 24px;

  .stat-item {
    padding: 12px 20px;
  }

  .stat-number {
    font-size: 32px;
    font-weight: 700;
    color: #00ffd0;
    line-height: 1.2;
  }

  .stat-label {
    font-size: 13px;
    color: #ccc;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin-top: 4px;
  }
}

.rotating-word {
  display: inline-block;
  min-width: 280px;

  span {
    display: inline-block;
  }
}

.word-fade-enter-active,
.word-fade-leave-active {
  transition: all 0.5s ease;
}

.word-fade-enter {
  opacity: 0;
  transform: translateY(20px);
}

.word-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

// Tablet
@media (max-width: 768px) {
  .hero-wrapper {
    height: auto;
    min-height: 100vh;
  }

  .hero-buttons {
    flex-direction: column;

    .btn {
      margin-left: 0 !important;
      text-align: center;
    }
  }

  .rotating-word {
    min-width: 200px;
  }

  .stats-row {
    .stat-item {
      padding: 8px 10px;
    }

    .stat-number {
      font-size: 24px;
    }

    .stat-label {
      font-size: 11px;
      letter-spacing: 1px;
    }
  }
}

// Mobile
@media (max-width: 480px) {
  .hero-wrapper {
    height: auto;
    min-height: 100vh;
  }

  .rotating-word {
    min-width: 160px;
  }

  .stats-row {
    padding-top: 16px;

    .stat-item {
      padding: 6px 8px;
    }

    .stat-number {
      font-size: 20px;
    }

    .stat-label {
      font-size: 10px;
      letter-spacing: 1px;
    }
  }
}
</style>
